import { createFileRoute } from "@tanstack/react-router";

import { Navigate } from "@/lib/router-compat";
export const Route = createFileRoute("/_public/privacy-policy")({
  component: () => <Navigate to="/privacy" replace />,
});
